import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { useFormContext } from 'react-hook-form';
import { ScreenAndProtectDetailsFormSchemaType } from '../ScreenAndProtectDetails.schema';
import usePropertiesSelectModal from './usePropertiesSelectModal';

const PropertiesSelect = () => {
  const {
    setValue,
    getValues,
    formState: { defaultValues },
  } = useFormContext<ScreenAndProtectDetailsFormSchemaType>();
  const { openPropertiesSelectModal } = usePropertiesSelectModal();
  const { t } = useTranslation();

  const handleOpenModal = () => {
    openPropertiesSelectModal({
      onUpdate: (properties: string[]) => {
        setValue('selectedProperties', properties);
      },
      selectedProperties:
        (getValues('selectedProperties') as string[]) ??
        defaultValues?.selectedProperties,
    });
  };

  return (
    <Button
      bsStyle="link"
      onClick={handleOpenModal}
      data-testid="open-properties-select-modal"
      data-intercom-target="details-screen-protect-properties"
    >
      {t(
        'pageScreenAndProtect.detailsPage.sections.protectionDetails.propertiesValue',
      )}
    </Button>
  );
};

export default PropertiesSelect;
